import React, { useRef } from "react";
import Header from "../../header.js";
import Footer from "../../footer.js";
import StreamDisplay from "../../streamDisplay.jsx";
import { videoList } from "../../VideoResults/videoResultsHoloX.js";

const resultsArr = videoList.Iroha;

class Iroha extends React.Component{
    render(){
    
      return(
            <div id="wrapper">

				{/* Header */}
				<Header />

				{/* Menu */}

				{/* Main */}
                <StreamDisplay talentName="Kazama Iroha" results={resultsArr} />


        {/* Footer */}
            <Footer />

    </div>
    )
}
}

export default Iroha